import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function PublicJobDetailSkeleton() {
  return (
    <div className="space-y-6" aria-hidden="true">
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="p-6 pb-0">
          <Skeleton className="h-8 w-3/4" />
        </div>

        <div className="px-6 pt-4">
          <div className="flex flex-wrap gap-2">
            <Skeleton className="h-6 w-20 rounded-full" />
            <Skeleton className="h-6 w-24 rounded-full" />
            <Skeleton className="h-6 w-28 rounded-full" />
          </div>
        </div>

        <div className="px-6 py-5 space-y-3">
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-4 w-1/3" />
        </div>
      </div>

      {[0, 1, 2].map((i) => (
        <Card
          key={i}
          className="shadow-sm border border-gray-200 rounded-xl overflow-hidden"
        >
          <CardHeader className="pb-3">
            <Skeleton className="h-4 w-40" />
          </CardHeader>
          <CardContent className="pt-0 px-6 pb-6 space-y-2.5">
            <Skeleton className="h-3.5 w-full" />
            <Skeleton className="h-3.5 w-11/12" />
            <Skeleton className="h-3.5 w-2/3" />
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
